// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"5bbc8197","453":"54342de2","543":"4249cb54"}[chunkId] + ".chunk.js";
};